import { UsersQueries } from '@frontend/api-users';

export const useGetUserFromUserId = (userId?: string, enabled?: boolean) => {
  const id = enabled && userId ? userId : '';

  return UsersQueries.useGetUserDetails(id);
};
